export default __webpack_public_path__ + "static/media/logoline-white.239c0933.png";